import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

// 🔑 Se muestra al abrir el enlace de "¿Olvidaste tu contraseña?": la persona
// escribe su contraseña nueva dos veces y entra directo a Kontrol.
export default function NuevaClaveView() {
  const { cambiarClave } = useAuth();
  const [clave, setClave] = useState('');
  const [repetir, setRepetir] = useState('');
  const [error, setError] = useState(null);
  const [guardando, setGuardando] = useState(false);

  const guardar = async (e) => {
    e.preventDefault();
    setError(null);
    if (clave.length < 8) { setError('La contraseña debe tener al menos 8 caracteres.'); return; }
    if (clave !== repetir) { setError('Las dos contraseñas no son iguales.'); return; }
    setGuardando(true);
    const { error: err } = await cambiarClave(clave);
    setGuardando(false);
    if (err) {
      const m = (err.message || '').toLowerCase();
      setError(m.includes('weak') || m.includes('pwned') ? 'Esa contraseña es muy común o insegura. Usa una diferente.'
        : m.includes('same') || m.includes('different') ? 'Usa una contraseña distinta a la anterior.'
          : m.includes('session') || m.includes('jwt') ? 'El enlace ya venció. Vuelve a pedirlo en "¿Olvidaste tu contraseña?".'
            : 'No se pudo guardar. Intenta de nuevo.');
    }
  };

  const input = { width: '100%', padding: '12px', border: '1px solid #D1D5DB', borderRadius: '10px', fontSize: '14px', boxSizing: 'border-box', marginBottom: '12px' };
  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#FDF2F8', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px', fontFamily: 'Arial, sans-serif' }}>
      <form onSubmit={guardar} style={{ backgroundColor: 'white', borderRadius: '20px', padding: '32px', width: '400px', maxWidth: '100%', boxShadow: '0 8px 30px rgba(109,40,217,0.15)', boxSizing: 'border-box' }}>
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <img src="/logo192.png?v=2" alt="Kontrol" width="60" height="60" style={{ borderRadius: '14px', marginBottom: '8px' }} />
          <h1 style={{ margin: 0, fontSize: '22px', color: '#6D28D9' }}>Crea tu contraseña nueva</h1>
          <p style={{ margin: '6px 0 0', fontSize: '13px', color: '#6B7280' }}>Escríbela dos veces. Mínimo 8 caracteres.</p>
        </div>
        <input style={input} type="password" placeholder="Contraseña nueva" autoComplete="new-password" value={clave} disabled={guardando} onChange={(e) => setClave(e.target.value)} />
        <input style={input} type="password" placeholder="Repite la contraseña" autoComplete="new-password" value={repetir} disabled={guardando} onChange={(e) => setRepetir(e.target.value)} />
        {error && <p style={{ margin: '0 0 12px', fontSize: '13px', color: '#DC2626', backgroundColor: '#FEE2E2', padding: '10px', borderRadius: '8px' }}>⚠️ {error}</p>}
        <button type="submit" disabled={guardando}
          style={{ width: '100%', padding: '14px', backgroundColor: guardando ? '#9CA3AF' : '#6D28D9', color: 'white', border: 'none', borderRadius: '10px', fontSize: '15px', fontWeight: 'bold', cursor: guardando ? 'wait' : 'pointer' }}>
          {guardando ? '⏳ Guardando...' : 'Guardar y entrar'}
        </button>
      </form>
    </div>
  );
}
